import { render, staticRenderFns } from "./ChallengeDetail.vue?vue&type=template&id=1f602f74&scoped=true&"
import script from "./ChallengeDetail.vue?vue&type=script&lang=js&"
export * from "./ChallengeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeDetail.vue?vue&type=style&index=0&id=1f602f74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f602f74",
  null
  
)

export default component.exports